// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ti-0";